import { createAuthorizedGetRequest, createAuthorizedPostRequest, decode, fetchApi, setBody } from '@/services/api';
import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { coursePlainCodec } from '../course/codec';

const baseUrl = '/v2/trainings/course-take';
const recordUrl = (id: number) => `${baseUrl}/${id}`;

export const getForTake = (id: number) => pipe(
  recordUrl(id),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(coursePlainCodec)),
);

export const submitCourse = (id: number) => pipe(
  recordUrl(id),
  createAuthorizedPostRequest,
  map(setBody({})),
  chain(fetchApi),
);
